import { CircularProgress, Typography } from '@material-ui/core'

import { addCommaToPrice } from '../../helpers/numbers'
import { getTranslate } from '../../localization'
import { Currency } from '../../types/currency'
import useStyles from './styles/index.styles'

type WalletCartProps = {
  icon: JSX.Element
  title: string
  balance: number
  currency: Currency
  subTitle?: string
  cashBalance: boolean
  loading?: boolean
}

export default function WalletCart({
  icon,
  title,
  balance,
  currency,
  subTitle,
  cashBalance,
  loading = false
}: WalletCartProps) {
  const classes = useStyles()

  return (
    <div
      className={[classes.root, cashBalance && classes.rootCashBalance].join(
        ' '
      )}>
      <div className={classes.topSection}>
        {icon}
        <div className={classes.titleAndBalance}>
          <Typography variant="h4" className={classes.title}>
            {title}
          </Typography>
          {loading ? (
            // Show loading spinner when loading is true
            <CircularProgress size={24} className={classes.loadingSpinner} />
          ) : (
            // Show the balance if loading is false
            <Typography variant="h2">{`${addCommaToPrice(
              balance
            )} ${getTranslate(currency || '')}`}</Typography>
          )}
        </div>
      </div>
      {subTitle && (
        <div className={classes.subTitle}>
          <Typography variant="h6">{subTitle}</Typography>
        </div>
      )}
    </div>
  )
}
